import { render, staticRenderFns } from "./DetailOrder.vue?vue&type=template&id=64d61f2c&scoped=true&"
import script from "./DetailOrder.vue?vue&type=script&lang=js&"
export * from "./DetailOrder.vue?vue&type=script&lang=js&"
import style0 from "./DetailOrder.vue?vue&type=style&index=0&id=64d61f2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d61f2c",
  null
  
)

export default component.exports